export default function urlAPI() {
 
  switch (process.env.REACT_APP_ENV) {
    case "development":
      return process.env.REACT_APP_API_DEVELOPMENT;

    case "production":
      return process.env.REACT_APP_API_PRODUCTION;

    default:
      return null;
  }
}

export function urlApiArquivos() {
  return process.env.REACT_APP_API_ARQUIVOS;
}

export function urlApiReports() {
  return process.env.REACT_APP_API_REPORTS;
}

